import type { TableProps } from 'antd';
 export interface DataType {
  id: number,
  category:string,
  brand: string,
  productName: string,
  channelName: string,
  productImg: string,
  productDesc: string,
  parvalue: number,
  status: number,
  channelAppId: number,
  channelProductId: string,
  productType: string,
  createTime: string,
  updateTime: string,
  valueTag:number,
  costPrice:number,
  productIcon:string,
  stock:number,
  arrivalTime:string,
  selectNum:number
}

export const column: TableProps<DataType>['columns'] = [
  {
    title: '权益分类',
    dataIndex: 'category',
    key: 'category',
  },
  {
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: '权益名称',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '权益类型',
    dataIndex: 'productType',
    key: 'productType',
  },
  {
    title: '充值应用',
    dataIndex: 'channelName',
    key: 'channelName',
  },
  {
    title: '库存',
    dataIndex: 'stock',
    key: 'stock',
  },
  {
    title: '成本价',
    dataIndex: 'costPrice',
    key: 'costPrice',
  },
  {
    title: '渠道权益标识',
    dataIndex: 'channelProductId',
    key: 'channelProductId',
    width:100
  },
  {
    title: '面值',
    dataIndex: 'parvalue',
    key: 'parvalue',
  },
];